if (isNullOrUndefined(sumo)) {
    throw ('PopupControl.js requires the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('PopupControl.js requires the sumo.controls namespace defined in ControlBase.js');
}
/**
 * @class
 * @namespace
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * @example
 *  mEnrolleesControls.OffenderHeatMapHelpPopup = new sumo.controls.PopupControl("lEnrolleeHeatMapHelpCardPopup", "uEnrolleessHeapMapHelpContainer", {
 *      "DataSource": [lEnrollee],
 *      "Html": '<div></div>',
 *      "CardTemplate": 'Interface/Enrollees.Offenders.HeatMaps.Help.layout.htm',
 *      "popupStyle": "qtip-lightCard qtip-max-width qtip-max-zindex",
 *      "popupPosition": {
 *          my: 'top rigth',
 *          at: 'bottomLeft'
 *      }
 * });
 */
sumo.controls.PopupControl = function (aId, aParentId, aOptions) {
    var mDataSource = null,
        mThis = this,
        mCardTemplate = "",
        mTemplateType = "uri",
        mCssClass,
        mKeyField = null,
        mHtml = '',
        mIsInitialized = false,
        mPopupStyle,
        mPopupPosition;
       

    if (!this.isNothing(aOptions.DataSource)) {
        this.mDataSource = aOptions.DataSource;
    } else {
        throw (this.className() + ': DataSource is required');
    }

    if (!this.isNothing(aOptions.CardTemplate)) {
        this.mCardTemplate = aOptions.CardTemplate;
    } else {
        throw (this.className() + ': CardTemplate is required');
    }

    if (!this.isNothing(aOptions.Html)) {
        this.mHtml = aOptions.Html;
    } else {
        throw (this.className() + ': Html is required');
    }

    if (!this.isNothing(aOptions.popupStyle)) {
        this.mPopupStyle = aOptions.popupStyle;
    } else {
        this.mPopupStyle = 'qtip-tipsy qtip-shadow';

    }

    if (!this.isNothing(aOptions.popupPosition)) {
        this.mPopupPosition = aOptions.popupPosition;
    } else {
        this.mPopupPosition = {
            my: 'top left',  
            at: 'bottom right'
        };
    }
    
    sumo.controls.PopupControl.prototype.baseClass.call(this, aId, aParentId, this.mHtml, aOptions);
       
    function onInitialized(aSender, aEventParameters, aData) {
        aSender.unbind('initialized', onInitialized);
        aSender.render();
    }

    function loadTemplateSuccess(responseText, textStatus, XMLHttpRequest) {
        mTemplateHtml = responseText;
        mIsInitialized = true;
        if (!isNullOrUndefined(mThis)) {
            mThis.trigger('initialized', null);
        }
    }

    function loadTemplateHtml() {
        $.get(mThis.mCardTemplate, loadTemplateSuccess);
    }

    function bindDataToTemplate(aString, aItem) {
        var lKey,
            lPropertyValue,
            lFormattedValue,
            lSearchKey,
            lResult = aString;
        for (lKey in aItem) {
            if (aItem.hasOwnProperty(lKey)) {
                lPropertyValue = aItem[lKey];
                lFormattedValue = '';
                if (!mThis.isNothing(lPropertyValue)) {
                    lFormattedValue = lPropertyValue.toString();
                }
                lSearchKey = '##' + lKey + '##';
                while (lResult.indexOf(lSearchKey) !== -1) {
                    lResult = lResult.replace(lSearchKey, lFormattedValue);
                }
            }
        }
        return lResult;
    }

    function getBodyContent() {
        var lHtml = [],
            lRowKey = null,
            lRow = null,
            lRowIndex = 0;

        mViewIndex = [];
        mDataIndex = {};
        for (lRowKey in mThis.mDataSource) {
            if (mThis.mDataSource.hasOwnProperty(lRowKey)) {
                lRow = mThis.mDataSource[lRowKey];
                if (mThis.isNothing(lRow)) {
                    throw (mThis.className() + '.Id: ' + mThis.Id + '. Error binding data. Item with hash index of ' + lRowKey.toString() + ' does not exist.');
                }
                lHtml.push('<div class="sumo-data-row" id="');
                lHtml.push(mThis.Id);
                lHtml.push('Row');
                if (mKeyField !== null) {
                    mViewIndex.push(lRow[mKeyField]);
                    mDataIndex[lRow[mKeyField]] = lRowKey;
                    lHtml.push(lRow[mKeyField]);
                } else {
                    mViewIndex.push(lRowKey);
                    mDataIndex[lRowKey] = lRowKey;
                    lHtml.push(lRowKey);
                }
                lHtml.push('" itemkey="');
                lHtml.push(lRowIndex.toString());
                lHtml.push('">');
                lHtml.push(bindDataToTemplate(mTemplateHtml, lRow));
                lHtml.push('</div>');
                ++lRowIndex;
            }
        }

        return lHtml.join('');
    }

    function dataBind() {
        if (mIsInitialized) {
            if (!mThis.isNothing(mThis.mDataSource)) {             
                $('#' + mThis.ParentId).qtip({
                    content: {
                        text: getBodyContent()
                    },
                    position: {
                        my: mThis.mPopupPosition.my,  // Position my top left...
                        at: mThis.mPopupPosition.at, // at the bottom right of...
                        target: $('#' + mThis.ParentId)
                    },
                    style: {
                        classes: mThis.mPopupStyle
                    },
                    events: {
                        show: function () {
                            veritracks.localization.localize('.qtip-content');
                        }
                    },
                    show: {
                        modal: {
                            on: true,
                            effect: function (state) {
                                $(this).fadeTo(90, state ? 0.4 : 0, function () {
                                    if (!state) { $(this).hide(); }
                                });
                            }
                        }
                    } 
                }); //end of qtip    

            }//end of if            
        }//end of if
    }

    this.setDataSource = function (aDataSource) {
        mDataSource = aDataSource;
        mIsDirty = true;
        if (!this.isNothing(mDataSource)) {
            dataBind();
        }
    };

    this.getDataSource = function () {
        return mDataSource;
    };

    this.render = function () {
        if (!mIsInitialized) {
            if (mTemplateType === 'uri') {
                this.bind('initialized', onInitialized, null);
                loadTemplateHtml(this);
                return 0;
            } else {
                mTemplateHtml = mCardTemplate;
                mIsInitialized = true;
            }
        }
        if (this.isNothing(mDataSource)) {
            dataBind();
        }
        if (!this.isNothing(mCssClass)) {
            this.ControlElement.addClass(mCssClass);
        }

        this.trigger('render');
    };

    this.render();
};

sumo.controls.PopupControl.prototype = new sumo.controls.ControlBase();
sumo.controls.PopupControl.prototype.constructor = sumo.controls.PopupControl;
sumo.controls.PopupControl.prototype.baseClass = sumo.controls.ControlBase;